// Константы для приложения
export const APP_CONSTANTS = {
  SNACKBAR_DURATION: 6000,
  API_TIMEOUT: 30000,
  COPY_SUCCESS_MESSAGE: 'Фич-лист скопирован в буфер обмена! Теперь вы можете вставить его в Excel.',
  FEATURE_UPDATED_MESSAGE: 'Описание фичи успешно обновлено',
  SERVER_AVAILABLE_MESSAGE: 'Сервер доступен',
  SERVER_UNAVAILABLE_MESSAGE: 'Сервер недоступен',
} as const;

// Сообщения об ошибках
export const ERROR_MESSAGES = {
  INVALID_RESPONSE: 'Неверный формат ответа от сервера',
  UNKNOWN_ERROR: 'Неизвестная ошибка',
  NETWORK_ERROR: 'Сервер не отвечает. Проверьте, что бэкенд запущен на порту 8080',
  REQUEST_ERROR: 'Ошибка запроса',
  SERVER_ERROR: 'Сервер недоступен',
} as const;

// Плейсхолдеры
export const PLACEHOLDERS = {
  TOKEN: 'Введите ваш токен авторизации',
  REQUIREMENTS: 'Например: Нужно создать веб-приложение для управления задачами с авторизацией, созданием проектов и отслеживанием прогресса',
  FEATURE_REFINEMENT: 'Опишите, что именно нужно доуточнить в этой фиче...',
} as const;
